import React from 'react'
import i18n from 'src/shared/i18n'
import {isUsp} from 'src/shared/utils'

import {DOWNLOAD_YANDEX_APP} from './consts'
import type {PromoProps} from './types'
import YandexPromoBase from './YandexPromoBase'

const YandexPromo: React.FC<PromoProps> = ({fullWidth = false, onClick, deeplink}) => {
  const isUspService = isUsp()
  const text = isUspService
    ? i18n.print('route_promo_text_usp', 'легко заказать уборку')
    : i18n.print('route_promo_text')

  return <YandexPromoBase fullWidth={fullWidth} link={deeplink || DOWNLOAD_YANDEX_APP} onClick={onClick} text={text} />
}
export default YandexPromo
